"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvenanceSection = void 0;
var react_1 = __importDefault(require("react"));
var element_popup_service_1 = require("./services/element-popup.service");
/**
 * Renders the verbatim sentence the extraction agent parsed for the
 * current element + use case combination. Lets the manager validate
 * the parse without leaving the popup. When `mentionId` is provided,
 * also renders Confirm / Reject buttons that update the mention
 * review status server-side.
 */
exports.ProvenanceSection = function (_a) {
    var provenance = _a.provenance;
    var initial = (provenance === null || provenance === void 0 ? void 0 : provenance.reviewedBy) ? 'confirmed' : 'idle';
    var _b = react_1.default.useState(initial), state = _b[0], setState = _b[1];
    react_1.default.useEffect(function () {
        setState((provenance === null || provenance === void 0 ? void 0 : provenance.reviewedBy) ? 'confirmed' : 'idle');
    }, [provenance === null || provenance === void 0 ? void 0 : provenance.mentionId, provenance === null || provenance === void 0 ? void 0 : provenance.reviewedBy]);
    if (!provenance)
        return null;
    var handleReview = function (decision) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!provenance.mentionId || state === 'submitting')
                        return [2 /*return*/];
                    setState('submitting');
                    return [4 /*yield*/, element_popup_service_1.reviewElementMention(provenance.mentionId, decision)];
                case 1:
                    result = _a.sent();
                    if (!result) {
                        setState('error');
                        return [2 /*return*/];
                    }
                    setState(decision === 'confirm' ? 'confirmed' : 'rejected');
                    return [2 /*return*/];
            }
        });
    }); };
    var showActions = typeof provenance.mentionId === 'number';
    var disabled = state === 'submitting' || state === 'confirmed' || state === 'rejected';
    return (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "provenance" },
        react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" },
            "Source ",
            react_1.default.createElement("span", { style: { color: '#6b7280', fontWeight: 400 } },
                "\u00B7 ",
                provenance.section),
            provenance.role ? (react_1.default.createElement("span", { className: "ws-entity-popup-chip", style: {
                    marginLeft: 8,
                    padding: '1px 8px',
                    fontSize: 11,
                    fontWeight: 500,
                    background: provenance.role === 'solves' ? '#dbeafe' : '#f3f4f6',
                    color: provenance.role === 'solves' ? '#1e40af' : '#4b5563',
                } }, provenance.role === 'solves' ? 'Solves' : 'Mentions')) : null),
        react_1.default.createElement("blockquote", { className: "ws-entity-popup-callout-block", style: { fontStyle: 'italic' } },
            "\u201C",
            provenance.excerpt,
            "\u201D"),
        showActions ? (react_1.default.createElement("div", { className: "ws-entity-popup-provenance-actions" },
            react_1.default.createElement("button", { type: "button", disabled: disabled, onClick: function () { return handleReview('confirm'); }, className: "ws-entity-popup-chip", style: {
                    border: 'none',
                    cursor: disabled ? 'default' : 'pointer',
                    background: state === 'confirmed' ? '#d1fae5' : '#f3f4f6',
                    color: '#065f46',
                } },
                react_1.default.createElement("i", { className: "ms-Icon ms-Icon--CheckMark", "aria-hidden": "true", style: { marginRight: 4 } }),
                state === 'confirmed' ? 'Confirmed' : 'Confirm'),
            react_1.default.createElement("button", { type: "button", disabled: disabled, onClick: function () { return handleReview('reject'); }, className: "ws-entity-popup-chip", style: {
                    border: 'none',
                    cursor: disabled ? 'default' : 'pointer',
                    background: state === 'rejected' ? '#fee2e2' : '#f3f4f6',
                    color: '#991b1b',
                } },
                react_1.default.createElement("i", { className: "ms-Icon ms-Icon--Cancel", "aria-hidden": "true", style: { marginRight: 4 } }),
                state === 'rejected' ? 'Rejected' : 'Reject'),
            state === 'error' ? (react_1.default.createElement("span", { style: { color: '#dc2626', fontSize: 12 } }, "Couldn\u2019t save \u2014 try again.")) : null,
            provenance.reviewedBy && state === 'confirmed' ? (react_1.default.createElement("span", { style: { color: '#6b7280', fontSize: 12 } },
                "Reviewed by ",
                provenance.reviewedBy)) : null)) : null));
};
